<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="home-banner">
      <el-carousel :interval="5000" arrow="always" height="6.3rem">
        <el-carousel-item v-for="(item,index) in banner" :key="index">
          <div class="carousel" v-if="item.id == 0">
            <img :src="item.url" alt="" class="bannerImg">
            <div class="carousel-title">{{item.title}}</div>
            <div class="carousel-item" >
              <div v-for="(v,k) in item.detail" :key="k">
                <div>{{v.name}}</div>
                <img :src="v.url" alt="">
              </div>                
            </div>
            <img :src="item.righturl" class="carousel-right" alt="">
          </div>        
          <div class="carousel" v-else>
            <img :src="item.url" alt="" class="bannerImg">
            <div class="carousel-title">{{item.title}}</div>
            <div class="carousel-detail">{{item.detail}}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    
    <!-- 智慧城市 -->
    <div class="home-city">
      <div class="home-city-title">
        <div>case</div>
        <div>智慧城市整体解决案例</div> 
        <div></div>
      </div>
      <div class="home-city-content">
        <img src="../assets/img/home/home_solution_left.png" alt="">
        <div  class="home-city-content-item">
          <div class="home-city-content-item-info" v-for="(item,index) in solutionList" :key="index" :class="{active:item.id == current}" @click="more(item)">
            {{item.title}}
            <img class="home-city-content-item-info-choose" :style="{display:(item.id == current ? 'block':'none')}" src="../assets/img/home/home_solution_right.png" alt="">
          </div>
          <div class="home-city-content-item-more" @click="more">了解更多</div>
        </div>
      </div>
    </div>
    <!-- 技术支持 -->
    <div class="home-technology">
      <div class="home-technology-title">
        <div>TECHNOLOGY</div>
        <div>技术支持</div> 
      </div>
      <div class="home-technology-content">
        <div v-for="(item,index) in techList" :key="index">
          <img :src="item.url" alt="">
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>    
    <!-- 新闻中心 -->
    <div class="home-news">
      <div class="home-news-title">
        <div>新闻中心</div> 
        <div>实现每一位客户的需求，提供全程智能化精准服务</div>
        <div @click="getNewsDetail(0)">查看更多</div>
      </div>
      <div class="home-news-content">
        <div class="home-news-content-left">
          <div>最新资讯</div>
        </div>
        <div class="home-news-content-right">
          <el-carousel trigger="click" :interval="6000" class="newscarousel">
            <el-carousel-item v-for="item in count" :key="item">
              <div v-for="(v,k) in newList" :key="k">                  
                  <div v-if="k < item*3 & k >= 3*(item-1)" class="news-item" @click="getNewsDetail(1,v)"> 
                    <div  class="news-item-second" >
                      <div class="news-item-second-left" v-if="v.thumb"><img :src="v.thumb"  alt="" ></div>
                      <div class="news-item-second-right">
                        <div>{{v.title}}</div>
                        <div>{{v.description}}</div>
                        <div>{{v.updateTime}}</div>
                      </div>
                    </div>
                    <div class="news-item-nums">{{(item-1)*3+k+1}}</div>
                  </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="home-about">
      <div class="home-about-content">
        <img src="../assets/img/home/home_about.png" alt="">
        <div class="home-about-content-right">
          <div class="home-about-content-right-title">
            <div>ABOUT</div>
            <div>关于我们</div> 
            <div>全方位一站式服务</div>
            <div></div>
          </div>
          <div class="home-about-content-right-content">苏州吉埃思数据信息科技有限公司经营范围包括数据、信息领域内的技术开发，数据处理，信息技术咨询服务，数字内容服务，测绘地理信息服务;(依法须经批准的项目，经相关部门批准后方可开展经营活动)</div>
        </div>
      </div>       
    </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
import * as API from '../api/api'
export default {
  computed: {
    ...mapState({fileUrl:state => state.fileUrl})
  },
  data(){
    return{ 
      current:0,
      banner:[
        {
          id:0,
          url:require('../assets/img/home/home_banner1_bg.png'),
          title:'空间大数据分析平台',
          righturl:require('../assets/img/home/home_banner1_right.png'),
          detail:[
            {
              name:'安全',
              url:require('../assets/img/home/home_banner1_1.png')
            },
            {
              name:'智能',
              url:require('../assets/img/home/home_banner1_2.png')
            },
            {
              name:'准确',
              url:require('../assets/img/home/home_banner1_3.png')
            }
          ]
        },
        {
          id:1,
          url:require('../assets/img/home/home_banner2_bg.png'),
          title:'无人机航拍技术',
          detail:'精准、时效性强、对重点区域进行定点监控'
        },
        {
          id:2,
          url:require('../assets/img/home/home_banner3_bg.png'),
          title:'致力打造三维地理信息平台',
          detail:'乡村级多源、海量地理信息资源的管理和服务'
        },
      ],
      solutionList:[],
      techList:[
        {
          name:'二维地理信息平台',
          url:require('../assets/img/home/home_tech_1.png')
        },
        {
          name:'三维地理信息平台',
          url:require('../assets/img/home/home_tech_2.png')
        },
        {
          name:'物联网+应用平台',
          url:require('../assets/img/home/home_tech_3.png')
        },
        {
          name:'互联网+城市服务',
          url:require('../assets/img/home/home_tech_4.png')
        },
        {
          name:'空间大数据分析平台',
          url:require('../assets/img/home/home_tech_5.png')
        },
        {
          name:'无人机技术',
          url:require('../assets/img/home/home_tech_6.png')
        },
      ],
      newList: [ ],
    }
  },
  computed: {
    count: function () { //新闻列表的页数
      return Math.ceil(this.newList.length/3)
    }
  },
  mounted(){
    // this.getBanner()//轮播图获取
    this.getComponent(1,3)
    this.getComponent(3,10)
  },
  methods:{
    more(item){
      this.current=item.id
      setTimeout(()=>{
        this.$router.push({ path: '/solution' })
      },200)      
    },
    getNewsDetail(index,item){
      if (index == 0) {
        this.$router.push({ path: '/news'})
      } else {
        if (item.url) {
          window.open(item.url)
        }else{
          this.$router.push({name:'newsdetail',params: { detail: item }})
        } 
      }
      
      
    },
    getBanner(){
      let that=this
      API.getBanner(0).then(res=>{
        // console.log(res.data.imgs);
        that.banner=res.data.imgs
      })
    },
    getComponent(type,take){
      let that=this
      let params={
        ComponentType:type,
        page:1,
        take:take
      }
      API.getComponents(params).then(res=>{
        if (res&&res.data) {
          if (type == 1) {
            that.solutionList=res.data.contents
          }else{
            that.newList=res.data.contents.map(item=>{
              let time=item.updateTime.split('T')[0].split('-')
              item.day=time[2]
              item.month=time[1];
              item.year=time[0]
              return item
            })
          }
        } else {
          that.$message({
            message: '获取数据失败',
            type: 'warning',
            duration:4000
          })
        }
        
        
      })
    }
  }
}
</script>

<style lang="scss">
  .home{
    width: 100%;
    .el-carousel__indicator .el-carousel__button {
      background: #BFBFBF;
      height: 0.06rem;
      width: 0.46rem;
      border-radius: 0.3rem;
    } 
    // 选中状态
    .el-carousel__indicator.is-active .el-carousel__button {
      background: #0052D9;
    }
    &-banner{
      width: 100%;
      height: 6.3rem;
      // 轮播图指示点样式
      .el-carousel__indicators--horizontal{
        left: 3.7rem;
        bottom: 0.93rem;
      }      
      .el-carousel__container{
        width: 100%;
        .carousel{
          width: 100%;
          height: 100%;
          position: relative;
          .bannerImg{
            width: 100%;
            height: 100%;
          }
          &-title{
            font-size: 0.6rem;
            color: #000;
            font-weight: 400;
            letter-spacing: 4px;
            position: absolute;
            top: 2rem;
            left: 2.9rem;
            z-index: 100;
          }
          &-detail{
            font-size: 0.36rem;
            color: #000;
            font-weight: 400;
            letter-spacing: 4px;
            position: absolute;
            top: 3.3rem;
            left: 2.9rem;
            z-index: 100;
          }
          &-item{
            position: absolute;
            top: 3.1rem;
            left: 2.5rem;
            z-index: 100;
            display: flex;
            align-items: flex-start;
            width: 3.7rem;
            justify-content: space-evenly;
            color: #C6C6C6;
            font-size: 0.3rem;
            >div{
              text-align: center;
              >div{
                margin-bottom: 0.2rem;
              }
              >img{
                width: 0.37rem;
                height: 0.37rem;
              }
            }
          }
          &-right{
            width: 5.11rem;
            height: 3.61rem;
            position: absolute;
            z-index: 100;
            right: 4rem;
            top: 2rem;
            cursor: pointer;            
          }
          &-right:hover{
            animation: zy 2.5s .15s linear infinite;
            -moz-animation: zy 2.5s .15s linear infinite; /* Firefox */
            -webkit-animation: zy 2.5s .15s linear infinite; /* Safari and Chrome */
            -o-animation: zy 2.5s .15s linear infinite; /* Opera */
          }
          @-webkit-keyframes zy{
            10% {
              transform: rotate(15deg);
            }
            20% {
              transform: rotate(-10deg);
            }
            30% {
              transform: rotate(5deg);
            }
            40% {
              transform: rotate(-5deg);
            }
            50%,100% {
              transform: rotate(0deg);
            }
          }
          @-moz-keyframes zy{
            10% {
              transform: rotate(15deg);
            }
            20% {
              transform: rotate(-10deg);
            }
            30% {
              transform: rotate(5deg);
            }
            40% {
              transform: rotate(-5deg);
            }
            50%,100% {
              transform: rotate(0deg);
            }
          }
          @-o-keyframes zy{
            10% {
              transform: rotate(15deg);
            }
            20% {
              transform: rotate(-10deg);
            }
            30% {
              transform: rotate(5deg);
            }
            40% {
              transform: rotate(-5deg);
            }
            50%,100% {
              transform: rotate(0deg);
            }
          }
          @keyframes zy{
            10% {
              transform: rotate(15deg);
            }
            20% {
              transform: rotate(-10deg);
            }
            30% {
              transform: rotate(5deg);
            }
            40% {
              transform: rotate(-5deg);
            }
            50%,100% {
              transform: rotate(0deg);
            }
          }
          .bannerTitle{
              font-size: 0.48rem;
              color: #fff;
              position: absolute;
              top: 50%;
              text-align: center;
              left: 0;
              right: 0;
              font-weight: 500;
              >div:last-child{
                margin-top: 0.2rem;
                font-size: 0.18rem;
              }
          }
        }
        
      }
    }
    
    &-city{
      width: 12rem;
      margin: auto;
      &-title{
        margin-top: 0.6rem;        
        position: relative;
        >div:nth-child(1){
          position: relative;
          color: #E4EBFE;
          font-size: 1.4rem;
        }
        >div:nth-child(2){
          position: absolute;
          top: 1.2rem;
          font-size: 0.38rem;
          font-weight: 350;
        }
        >div:nth-child(3){
          width: 0.5rem;
          height: 6px;
          background: #0052D9;
          border-radius: 0.2rem;
          margin-left: 0.1rem;
          margin-top: 0.1rem;
        }
      }
      &-content{
        width: 12rem;
        margin: 1rem auto;
        display: flex;
        align-items: flex-end;
        >img{
          width: 6.42rem;
          height: 4.54rem;
        }
        &-item{
          margin-left: 1.2rem;
          &-info{
            font-size: 0.36rem;
            color: #C6C6C6;
            font-weight: 300;
            margin-bottom: 0.3rem;
            cursor: pointer;
            position: relative;
            &-choose{
              position: absolute;
              left: -0.3rem;
              top: 0.15rem;
              width: 0.13rem;
              height: 0.24rem;
              display: none;
            }
          }
          &-info:hover{
            color: #0052D9;
          }
          .active{
            color: #0052D9;
          }
          &-more{
            width: 1.64rem;
            height: 0.5rem;
            line-height: 0.5rem;
            text-align: center;
            color: #fff;
            background: #0052D9;
            font-size: 0.24rem;
            border-radius: 0.5rem;
            font-weight: 300;
            letter-spacing: 4px;
            cursor: pointer;
          }
          &-more:hover{
            background: #4DA4F3;
            color: #fff;
          }
        }
      }
    }
    &-technology{
      width: 100%;
      background: #F4F6FC;
      &-title{      
        position: relative;
        margin: auto;
        text-align: center;
        padding-top: 0.8rem;
        >div:nth-child(1){
          position: relative;
          color: #E4EBFE;
          font-size: 0.98rem;
        }
        >div:nth-child(2){
          position: absolute;
          top: 1.4rem;
          left: 0;
          font-size: 0.38rem;
          font-weight: 350;
          right: 0;
        }
      }
      &-content{
        padding-top: 0.6rem;
        padding-bottom: 0.75rem;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        >div{
          text-align: center;
          margin-right: 0.24rem;
          font-size: 0.18rem;
          // cursor: pointer;
          >div{
            margin-top: 20px;
          }
        }
      }
    }
    &-news{
      margin: 1.1rem auto;
      width: 12rem;
      &-title{
        color: #333333;
        font-size: 0.38rem;
        font-weight: 300;
        >div:nth-child(2){
          font-size: 0.24rem;
          color: #999;
          margin:0.25rem 0;
        }
        >div:nth-child(3){
          font-size: 0.24rem;
          color: #fff;
          width: 1.64rem;
          height: 0.5rem;
          text-align: center;
          line-height: 0.5rem;
          background: #0052D9;
          border-radius: 0.25rem;
          cursor: pointer;
        }
      }
      &-content{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin:0.5rem auto;
        height: 7rem;
        &-left{
          width: 50%;
          height: 100%;
          background-image: url('../assets/img/home/home_new_left.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          >div{
            position: absolute;
            top: 0;
            background: rgba($color: #242933, $alpha: 0.2);
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 7rem;
            color: #fff;
            font-size: 0.6rem;
            letter-spacing: 3px;
          }
        }
        &-right{
          width: 50%;
          height: 100%;
          background: #F4F6FC;
          padding: 0.4rem 0.36rem 0.25rem 0.36rem;
          box-sizing: border-box;
          .el-carousel__container{
            height: 100%;
          }
          .newscarousel{
            width: 100%;
            height: 100%;            
            .news-item{
              border-bottom: 1px dashed #B5B5B5;
              padding: 0.4rem 0;
              position: relative;
              &-second{
                display: flex;
                &-left{
                   width: 1.24rem;
                  height: 1.24rem;
                  overflow: hidden;
                  margin-right: 0.2rem;
                  >img{
                    width: 1.24rem;
                    height: 1.24rem;
                    cursor: pointer;
                    transition: all 0.6s;
                  }
                  >img:hover{
                    transform: scale(1.4);
                  }
                }                
                &-right{
                  cursor: pointer;
                  width: calc(100% - 1.4rem);
                  >div{
                    overflow: hidden;      
                    text-overflow: ellipsis;      
                    display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */   
                    -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */                    
                  }
                  >div:nth-child(1){
                     -webkit-line-clamp: 1; /* 控制最多显示几行 */  
                     font-size: 0.24rem;
                     color: #314659; 
                  }
                  >div:nth-child(1):hover , >div:nth-child(2):hover , >div:nth-child(3):hover{
                    color: #0052D9;
                  }
                  >div:nth-child(2) , >div:nth-child(3){
                     -webkit-line-clamp: 2; /* 控制最多显示几行 */   
                     font-size: 0.18rem;
                     color: #555555;
                     margin: 0.12rem 0;
                  }
                  >div:nth-child(3){
                     margin:0;
                  }
                }
              }              
              &-nums{
                position: absolute;
                right: 0;
                top: 0.1rem;
                color: #E4EBFE;
                font-size: 1.4rem;
                z-index: -1;
              }
            }
          }
        }
        
      }
    }
    &-about{
      width: 100%;
      background: #F4F6FC;
      padding: 1rem 0;
      // height: 8rem;
      &-content{
        width: 12rem;
        margin: auto;
        display: flex;
        justify-content: flex-end;
        position: relative;
        >img{
          width: 7rem;
          height: 4.65rem;
          position: absolute;
          left: 0;
          top: 0.8rem;
        }
        &-right{
          width: 7rem;
          height: 6.2rem;
          background: #fff;
          display: flex;
          justify-content: flex-end;
          flex-direction: column;
          &-title{
            margin-top: 1.1rem;        
            position: relative;
            margin-right: 0.5rem;
            >div:nth-child(1){
              position: relative;
              color: #E4EBFE;
              font-size: 1rem;
              width: 3.5rem;
              margin-left: auto;
            }
            >div:nth-child(2){
              position: absolute;
              top: 0.7rem;
              right: 0;
              font-size: 0.38rem;
              font-weight: 350;
              color: #555;
            }
            >div:nth-child(3){
              color: #999;
              font-size: 0.24rem;
              text-align: right;
            }
            >div:nth-child(4){
              width: 0.5rem;
              height: 6px;
              background: #0052D9;
              border-radius: 0.2rem;
              margin-top: 0.1rem;
              margin-left: auto;
            }
          }
          &-content{
            height: 4rem;
            width: 4rem;
            margin-left: auto;
            margin-right: 0.5rem;
            margin-top: 0.3rem;
            font-size: 0.24rem;
            color: #555;
            line-height: 0.35rem;
          }
        }
      }
    }
  }
.el-message .el-icon-warning{
  font-size: 20px;
}
  
</style>